module.exports = __webpack_public_path__ + "img/logo.27d468cd.png";